import { Box } from "@mui/material";
import { ReactNode } from "react";

interface TabPanelProps {
  children?: ReactNode;
  dir?: string;
  index: number;
  value: number;
  sx?: object;
}

export function TabPanel(props: Readonly<TabPanelProps>) {
  const { children, value, index, sx, ...other } = props;

  return (
    <Box role="tabpanel" hidden={value !== index} {...other} sx={sx}>
      <Box
        sx={{
          p: 3,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
